import {
  doc,
  type DocumentSnapshot,
  type FirestoreError,
} from 'firebase/firestore';
import { accountPaths, type UserIHaveSentInviteTo } from '@todesktop/shared';
import { firestore } from './firestore';
import { getSnapshot } from './common';

/** Advisory UI evidence; backend/rules remain authoritative. */
export function onAccountInvitationUpdate(
  accountId: string,
  lookupEmail: string,
  onUpdate: (
    invite: UserIHaveSentInviteTo | undefined,
    snapshot?: DocumentSnapshot,
  ) => void,
  onError: (error: FirestoreError) => void,
) {
  return getSnapshot<UserIHaveSentInviteTo | undefined>(
    doc(firestore, accountPaths.invitation(accountId, lookupEmail)),
    onUpdate,
    onError,
  );
}
